import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import moment from "moment";
import { Component } from "react";
import { Button, Form, Modal, Nav, OverlayTrigger, Tab, ThemeProvider, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaHourglassHalf, FaTimesCircle } from "react-icons/fa";
import { hasPermission } from "../utils/usePermission";
import { DateTimeFormat } from './DateFormat/DateTimeFormat';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from './Toaster/CommonToast';

export default class ApplicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applications: [],
      reporteesApplications: [],
      selectedTab: "self",
      hasError: false,
      errorMsg: "",
      completed: false,
      loading: false,
      userId: '',
      showModal: false,
      selectedApplication: null,
      newStatus: "",
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    };
  }
  checkToken = () => {
    let token = localStorage.getItem('token');
    axios({
      method: "get",
      url: "/checkToken",
      headers: { "Authorization": `Bearer ${token}` }
    })
      // .then((res) => {
      //   this.setState({ isAuthenticated: true, loading: false, userId: res?.data?.authData?.user.id });
      //   console.log("this is response", this.state.userId)
      // })
      .then((res) => {
        const userId = res?.data?.authData?.user?.id; // Extract userId
        this.setState({ isAuthenticated: true, loading: false, userId }, () => {
          this.fetchApplications();
          this.fetchReporteesApplications();
        });
      })
      .catch((err) => {
        console.log(err)
        console.log(`Access: ${this.state.isAuthenticated}`);
      });
  }

  componentDidMount() {
    this.checkToken();
  }


  fetchApplications = () => {
    this.setState({ loading: true });
    let u_id = this.state.userId
    console.log("u_id", u_id);
    axios.get(`/applications/self/${u_id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((res) => {
      res.data.forEach(app => {
        app.startDate = moment(app.startDate).format("YYYY-MM-DD");
        app.endDate = moment(app.endDate).format("YYYY-MM-DD");
      });
      this.setState({ applications: res.data, loading: false });
    });
  };

  fetchReporteesApplications = () => {
    this.setState({ loading: true });
    let u_id = this.state.userId
    console.log("u_id", u_id);
    axios.get(`/applications/reportees/${u_id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((res) => {
      res.data.forEach(app => {
        app.startDate = moment(app.startDate).format("YYYY-MM-DD");
        app.endDate = moment(app.endDate).format("YYYY-MM-DD");
      });
      this.setState({ reporteesApplications: res.data, loading: false });
    });
  };

  handleUpdateClick = (data, isReportees) => {
    if (isReportees) {
      this.setState({ showModal: true, selectedApplication: data, newStatus: data.status });
    } else {
      this.props.history.push(`/application/${data.id}`);
    }
  };


  handleStatusUpdate = () => {
    const { selectedApplication, newStatus } = this.state;
    if (!newStatus) {
      alert("Please select a status.");
      return;
    }
    axios
      .post(`/applications/status`, { id: selectedApplication.id, status: newStatus }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        this.setState({
          completed: true,
          toastMessage: "Status updated successfully!",
          toastVariant: 'success',
          color: 'green',
          showToast: true,
          showModal: false
        });

        this.fetchReporteesApplications();
      })
      .catch((err) => console.error("Error updating status:", err));
  };



  renderTable = (applications, isReportees) => {
    return (
      <ThemeProvider theme={createTheme()}>
        <MaterialTable
          columns={[
            {
              title: "APP ID", field: "id",
              cellStyle: { minWidth: 120 },
              headerStyle: { minWidth: 120 }
            },
            {
              title: "Full Name", field: "user.fullName",
              cellStyle: { minWidth: 250 },
              headerStyle: { minWidth: 250 }
            },
            {
              title: "Start Date", field: "startDate",
              render: (value) => DateTimeFormat(value.startDate),
              cellStyle: { minWidth: 120 },
              headerStyle: { minWidth: 120 }
            },
            {
              title: "End Date", field: "endDate",
              render: (value) => DateTimeFormat(value.endDate),
              cellStyle: { minWidth: 120 },
              headerStyle: { minWidth: 120 }
            },
            {
              title: "Leave Type", field: "type",
              cellStyle: { minWidth: 250 },
              headerStyle: { minWidth: 250 }
            },
            {
              title: "Comments", field: "reason",
              cellStyle: { minWidth: 250 },
              headerStyle: { minWidth: 250 }
            },

            {
              title: "Status",
              field: "status",
              render: (rowData) => {
                const status = rowData.status?.toLowerCase();

                const getStatusStyles = (status) => {
                  switch (status) {
                    case "approved":
                      return {
                        backgroundColor: '#d1e7dd',
                        color: '#0f5132',
                        border: '1px solid #badbcc',
                        icon: <FaCheckCircle />,
                      };
                    case "pending":
                      return {
                        backgroundColor: '#fff3cd',
                        color: '#664d03',
                        border: '1px solid #ffe69c',
                        icon: <FaHourglassHalf />,
                      };
                    case "rejected":
                    default:
                      return {
                        backgroundColor: "#f8d7da",
                        color: '#842029',
                        border: "1px solid #f5c2c7",
                        icon: <FaTimesCircle />,
                      };
                  }
                };

                const { icon, ...styleProps } = getStatusStyles(status);

                const styles = {
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: "0.75rem",
                  padding: '4px 12px',
                  borderRadius: '20px',
                  fontWeight: 500,
                  textTransform: "uppercase",
                  minWidth: "90px",
                  textAlign: "center",
                  ...styleProps,
                };

                return (
                  <span style={styles}>
                    {icon} {rowData.status}
                  </span>
                );
              }

            },
            {
              title: "Action",
              field: "",
              render: rowData =>
                rowData.status === "Pending" && (
                  <>
                    {hasPermission('M9S2B1') && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-edit-${rowData.id}`}>
                            {isReportees ? "Update Status" : "Update Leave"}
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          className="info"
                          variant={isReportees ? "outline-info" : "outline-info"}
                          onClick={() => this.handleUpdateClick(rowData, isReportees)}
                        >
                          <i className={`fas fa-${isReportees ? "sync-alt" : "edit"}`}></i>
                        </Button>
                      </OverlayTrigger>
                    )}
                  </>
                ),
              cellStyle: { width: '150px', minWidth: '150px', textAlign: 'center' }, // Adjust width as needed
              headerStyle: { width: '150px', minWidth: '150px', textAlign: 'center' }
            }
          ]}
          data={applications}
          options={{
            rowStyle: (rowData, index) => index % 2 ? { backgroundColor: "#f2f2f2" } : {},
            pageSize: 10,
            pageSizeOptions: [10, 20, 30, 50, 75, 100],
          }}
          title="Leaves"
        />
      </ThemeProvider>
    );
  };

  handleAddLeave = () => {
    this.props.history.push('/application')
  }
  render() {
    return (
      <div className="container-fluid pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M9S1') && (
            <div className='add-role'>
              <Button variant='primary'
                className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"
                onClick={this.handleAddLeave}> <i className="fa fa-plus-circle " aria-hidden="true"></i> Add Leave</Button>
            </div>
          )}
          <div className="container-fluid pt-2">
            <Tab.Container defaultActiveKey="self">
              <Nav variant="tabs">
                <Nav.Item>
                  <Nav.Link eventKey="self">Self</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="reportees">Reportees</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="self">{this.renderTable(this.state.applications, false)}</Tab.Pane>
                <Tab.Pane eventKey="reportees">{this.renderTable(this.state.reporteesApplications, true)}</Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>

          <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Update Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Form.Label className="required">Select Status</Form.Label>
                  <Form.Control
                    as="select"
                    className="form-select"
                    value={this.state.newStatus}
                    onChange={(e) => this.setState({ newStatus: e.target.value })}
                  >
                    <option value="">Select</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleStatusUpdate} size="sm">
                Update
              </Button>
              <Button
                variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.setState({ showModal: false })} size="sm">
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </CommonLoader>
      </div>
    );
  }
}